import { render } from "./VolumeChart.vue?vue&type=template&id=27de2816"
import script from "./VolumeChart.vue?vue&type=script&lang=js"
export * from "./VolumeChart.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__